import { fetchData } from '../../../http/Http';

export const fetchTagBySlug = async (slug: string) => {
    try {
        const response = await fetchData(`/tags/search?query=*&slug=${slug}`, 'GET');
        return response.data;
    } catch (e) {
        console.error('Error retrieving tag information: ', e);
        return null;
    }
};

export const fetchTagById = async (id: string) => {
    try {
        const response = await fetchData(`/tags/${id}`, 'GET');
        return response.data;
    } catch (e) {
        console.error('Error retrieving tag information: ', e);
        return null;
    }
};
